import tableOfContents from "./tableOfContents";

export default function(el) {
    tableOfContents(el, "toc-item--active", 1.2, true);
}
